export default __webpack_public_path__ + "static/media/extra_cost.562e6233.jpg";